import _ from 'lodash';
import config from './config';
import featureFlag from './api/featureFlag';

/* eslint-disable */
export default {
  install(Vue, options) {
    includeIntercom();
  },

  async boot(customerId, householdName, extraAttributes) {
    const intercomEnabled = config.get().intercomEnabled;
    const intercomStatus = await featureFlag.getAnonymousTreatment('intercom_status');
    const appId = intercomStatus === 'test' ?
      config.get().intercomTestAppId :
      config.get().intercomProdAppId;

    const normalizedExtraAttributes = _.mapKeys(extraAttributes, (v, k) => _.snakeCase(k));
    if (intercomEnabled === "true") {
      window.Intercom('boot', {
        app_id: appId,
        user_id: customerId,
        name: householdName,
        ...normalizedExtraAttributes,
      })
    }
  },
  show() {
    window.Intercom('show');
  },
  hide() {
    window.Intercom('hide');
  },
  hideLauncher() {
    window.Intercom('update', {
      'hide_default_launcher': true
    });
  },
  showLauncher() {
    window.Intercom('update', {
      'hide_default_launcher': false
    });
  },
  showNewMessage(prompt = '') {
    window.Intercom('showNewMessage', prompt);
  },
};

function includeIntercom() {
  const w = window;
  const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    const i = function() {
      i.c(arguments);
    };
    i.q = [];
    i.c = function(args) {
      i.q.push(args);
    };
    w.Intercom = i;
    const l = function() {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/APP_ID';
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    };
    if (document.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/Intercom.js